import { fetchSiteConfig } from '@/lib/api';

import { useLocalizedQuery } from './useLocalizedQuery';

import type { UseQueryOptions } from '@tanstack/react-query';

import type { SiteConfigResponse } from '@/lib/api/types';

export const useSiteConfig = (
  tenantId: string | undefined,
  options?: Omit<
    UseQueryOptions<SiteConfigResponse, Error>,
    'queryKey' | 'queryFn'
  >,
) => {
  const tenantKey = tenantId ?? null;

  return useLocalizedQuery<SiteConfigResponse, Error>(
    ['site-config', tenantKey],
    () => fetchSiteConfig(tenantId || undefined),
    {
      ...options,
      // if tenant is truly optional in your app, leave this enabled.
      // if tenant is required, change to Boolean(tenantId)
      enabled: options?.enabled ?? true,
    },
  );
};
